export enum TextSize {
  XXXS = 9,
  XXS = 10,
  XS = 12,
  S = 13,
  M = 14,
  L = 16,
  XL = 18,
  XXL = 24,
  XXXL = 36,
}
